import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroWelcomeToMotormtaaConnect() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="40704" id="orthodontic-treatments-overview" className="relative bg-background min-h-[600px] flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/smiling_braces_patient_aesthetic.png" alt="Ortodontik Tedavi" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-white/40 backdrop-blur-[2px]" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 py-20 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="max-w-4xl mx-auto space-y-8">
          <h1 className="font-serif font-light tracking-[0.15em] text-foreground uppercase text-[24px] md:text-[48px] lg:text-[64px] w-full max-w-4xl mx-auto leading-tight">
  HIZALAMADA MÜKEMMELLİYET
</h1>
          
          <p className="text-base md:text-base text-muted-foreground max-w-2xl mx-auto leading-[1.6] font-sans">
            Klinik lüksün zirvesini deneyimleyin. Ortodontik tedavilerimiz, gülüşünüzü dönüştürmek için hassas mühendisliği rafine bir estetik anlayışıyla birleştiriyor.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <Button asChild size="lg" className="w-full sm:w-auto text-base font-semibold h-12 px-8 bg-gradient-to-r from-[#C5A059] to-[#D4AF37] hover:opacity-90 text-primary-foreground rounded-sm border-none shadow-md transition-all duration-300">
              <Link to="https://wa.me/905535523234?text=Merhaba%20randevu%20almak%20istiyorum" newTab>
                Randevu Al
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base font-semibold h-12 px-8 bg-transparent text-foreground border-foreground hover:bg-foreground hover:text-background transition-colors rounded-sm">
              <Link to="/ContactPage">
                İletişim
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}